module.exports = __webpack_public_path__ + "media/fonts/Cormorant-MediumItalic-feaf12c138d632bba7e186c9d5a66670.woff";